<template>
  <AppLayout>
    <VFlex>
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard flat>
        <VFlex>
          <AgencyOverviewAgentsTable />
        </VFlex>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>

import AgencyOverviewAgentsTable from '@/components/routes/agency/AgencyOverviewAgentsTable'
export default {
  name: 'AgencyAgents',
  components: { AgencyOverviewAgentsTable }
}
</script>
